import React from 'react';
import styled from 'styled-components';
import Title from '../components/Title';

const AboutPage = () => (
  <div>
    <Title>About Page</Title>
  </div>
);

export default styled(AboutPage)`
  /* add any custom styles here */
`;